import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

const mode = (import.meta as any).env?.MODE || 'dev';
const origin = typeof window !== 'undefined' ? window.location.origin : 'ssr';
export const AUTH_STORAGE_KEY = `sb-210tattoo-auth-${mode}`;

function createSupabaseStub(): any {
  try { console.warn('[supabase] Env vars missing; using no-op stub client.'); } catch {}
  const makeQuery = () => ({
    select: () => makeQuery(),
    eq: () => makeQuery(),
    single: async () => ({ data: null, error: { code: 'PGRST116' } }),
    upsert: async () => ({ data: null, error: null }),
    update: async () => ({ data: null, error: null }),
  });
  return {
    auth: {
      async getSession() { return { data: { session: null }, error: null }; },
      onAuthStateChange(_cb: any) {
        return { data: { subscription: { unsubscribe() {} } }, error: null };
      },
      async getUser() { return { data: { user: null }, error: null }; },
      async signInWithPassword(_args: any) {
        return { data: { user: { id: 'stub', user_metadata: {}, app_metadata: {}, email: 'guest@example.com' } }, error: null };
      },
      async signInWithOAuth(_args: any) { return { data: {}, error: null }; },
      async resetPasswordForEmail(_email: string, _opts?: any) { return { data: {}, error: null }; },
      async updateUser(_data: any) { return { data: {}, error: null }; },
      async signOut() { return { error: null }; },
    },
    from(_table: string) { return makeQuery(); },
  };
}

// Migrate legacy storage key to env-scoped key (run before client creation)
if (typeof window !== 'undefined') {
  try {
    const legacyKey = 'sb-210tattoo-auth';
    const legacy = window.localStorage.getItem(legacyKey);
    if (legacy && !window.localStorage.getItem(AUTH_STORAGE_KEY)) {
      window.localStorage.setItem(AUTH_STORAGE_KEY, legacy);
      try { console.debug('[supabase] migrated session from legacy key'); } catch {}
    }
  } catch {}
}

// Ensure singleton instance (important under Vite HMR/dev)
const globalAny: any = typeof window !== 'undefined' ? (window as any) : {};
if (!globalAny.__supabase) {
  try { console.debug('[supabase] init', { mode, origin, storageKey: AUTH_STORAGE_KEY }); } catch {}
  const hasEnv = Boolean(supabaseUrl && supabaseAnonKey);
  globalAny.__supabase = hasEnv
    ? createClient(supabaseUrl!, supabaseAnonKey!, {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true,
          flowType: 'pkce',
          storageKey: AUTH_STORAGE_KEY,
          storage: typeof window !== 'undefined' ? window.localStorage : undefined,
        },
      })
    : createSupabaseStub();
}

export const supabase = globalAny.__supabase as ReturnType<typeof createClient>;


